import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
}

@Injectable({
  providedIn: "root",
})
export class LoggerService {
  private logLevel: LogLevel = environment.production ? LogLevel.ERROR : LogLevel.DEBUG;

  constructor() {}

  debug(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.DEBUG)) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  }

  info(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.INFO)) {
      console.info(`[INFO] ${message}`, ...args);
    }
  }

  warn(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.WARN)) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  }

  error(message: string, error?: any): void {
    if (this.shouldLog(LogLevel.ERROR)) {
      console.error(`[ERROR] ${message}`, error);

      // Em produção, enviar para serviço de monitoramento
      if (environment.production) {
        this.sendToMonitoring(message, error);
      }
    }
  }

  private shouldLog(level: LogLevel): boolean {
    return level >= this.logLevel;
  }

  private sendToMonitoring(message: string, error?: any): void {
    // TODO: Implementar envio para serviço de monitoramento (Sentry, LogRocket, etc.)
    // Por enquanto, apenas log local
    console.error(`[MONITORING] ${message}`, error);
  }

  // Método para configurar nível de log dinamicamente
  setLogLevel(level: LogLevel): void {
    this.logLevel = level;
  }
}
